import React, { useEffect, useState, useRef } from 'react';
import { Form, Input, Button, DatePicker, Row, Col } from 'antd';
import { Toast } from 'primereact/toast';
import { t } from 'i18next';
import HTTPService from '../../../../utils/makerequest';
import moment from 'moment';
import { SaveOutlined } from '@ant-design/icons';

const WarrantyTab = ({ inventoryId, setTabIndex }) => {
    const [form] = Form.useForm();
    const [warrantyData, setWarrantyData] = useState(null);
    const toast = useRef<any>(null);

    useEffect(() => {
        if (inventoryId != 0) {
            WarrantyById(inventoryId);
        }
    }, [inventoryId])

    const WarrantyRegister = () => {
        const formValues = form.getFieldsValue();

        const hasAnyValue = Object.values(formValues).some(value => {
            if (value instanceof moment) {
                return true;
            }
            return value !== undefined && value !== null && value !== '';
        });

        if (!hasAnyValue) {
            return;
        }

        form.validateFields()
            .then((values) => {
                const data = {
                    inventoryId: inventoryId,
                    warrantyStartDate: values.startDate ? moment(values.startDate).add(3, 'hours').toISOString() : null,
                    warrantyFinishDate: values.endDate ? moment(values.endDate).add(3, "hours").toISOString() : null,
                    warrantyDescription: values.description || '',
                };

                if (inventoryId !== 0) {
                    HTTPService.PUT(`/Inventory/createWarranty`, data)
                        .then((response) => {
                            if (response.status === 200) {
                                //setTabIndex(3);
                                toast.current?.show({
                                    severity: 'success',
                                    summary: t('successful'),
                                    detail: t('warranty_register_success'),
                                    life: 3000
                                });
                            } else {
                                toast.current?.show({
                                    severity: 'error',
                                    summary: t('errors'),
                                    detail: t(response.data),
                                    life: 3000
                                });
                            }
                        })
                        .catch((error) => {
                            console.error("Garanti kaydı başarısız: ", error);
                            toast.current?.show({
                                severity: 'error',
                                summary: t('errors'),
                                detail: t('warranty_register_failed'),
                                life: 3000
                            });
                        });
                }
            })
            .catch((error) => {
                console.error("Form doğrulama hatası:", error);
            });
    };


    const WarrantyById = (inventoryId: number) => {
        HTTPService.GET(`/Inventory/warrantyById?inventoryId=${inventoryId}`)
            .then((res) => {
                if (res.status === 200 && res.data) {
                    setWarrantyData(res.data);
                } else {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: t('error_fetching_data'),
                        life: 3000
                    });
                }
            })
            .catch((error) => {
                toast.current?.show({
                    severity: 'error',
                    summary: t('errors'),
                    detail: t('error_fetching_data'),
                    life: 3000
                });
                console.error("Error fetching warranty data:", error);
            });
    }

    return (
        <div>
            <Toast ref={toast} />
            <Form
                layout="vertical"
                form={form}
                onFinish={WarrantyRegister}
                fields={[
                    { name: ["startDate"], value: warrantyData?.warrantyStartDate ? moment(warrantyData.warrantyStartDate) : null },
                    { name: ["endDate"], value: warrantyData?.warrantyFinishDate ? moment(warrantyData.warrantyFinishDate) : null },
                    { name: ["description"], value: warrantyData?.warrantyDescription || null }
                ]}
            >
                <Form.Item
                    label={t('warranty_start_date')}
                    name="startDate"
                    rules={[{ required: true, message: t('select_date_time') }]}
                >
                    <DatePicker
                        showTime
                        format="DD-MM-YYYY HH:mm"
                        placeholder={t('select_date_time')}
                        style={{ width: '100%' }}
                    />
                </Form.Item>

                <Form.Item
                    label={t('warranty_end_date')}
                    name="endDate"
                    rules={[{ required: true, message: t('select_date_time') }]}
                >
                    <DatePicker
                        showTime
                        format="DD-MM-YYYY HH:mm"
                        placeholder={t('select_date_time')}
                        style={{ width: '100%' }}
                    />
                </Form.Item>

                <Form.Item
                    label={t('description')}
                    name="description"
                    rules={[{ required: true, message: t('enter_description') }]}
                >
                    <Input
                        placeholder={t('enter_description')}
                        style={{ borderRadius: '5px' }}
                    />
                </Form.Item>

                <Form.Item style={{ marginTop: '25px' }}>
                    <Row gutter={[8, 8]} justify="end" align="middle">
                        <Col xs={12} sm={12} md={4}>
                            <Button
                                block
                                htmlType="submit"
                                type="primary"
                                style={{
                                    height: 64,
                                    backgroundColor: 'transparent',
                                    color: '#1890ff',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '0 10px',
                                    border: 'none',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'scale(1.05)';
                                    e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                                    e.currentTarget.style.color = '#40a9ff';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'scale(1)';
                                    e.currentTarget.style.boxShadow = 'none';
                                    e.currentTarget.style.color = '#1890ff';
                                }}
                            >
                                <SaveOutlined style={{ fontSize: 20 }} />
                                <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                                    {t('save')}
                                </span>
                            </Button>
                        </Col>
                    </Row>
                </Form.Item>
            </Form>
        </div>
    );
};

export default WarrantyTab;
